import gql from 'graphql-tag';

export default gql`
  query findUnfinishedHomeTaskLessonsQuery($course: MongoID!, $courseCategory: MongoID!, $student: MongoID) {
    findUnfinishedHomeTaskLessonsQuery(course: $course, courseCategory: $courseCategory, student: $student) {

      _id
      id
      title
      data {
        student
        course
        courseCategory
        homeTaskStatus
        isZeroLesson
      }
      workOnHomeTask {
        notes
      }
      homeTask {
        _id
        title
        notes
        filesStatuses {
          file
          status
          updatedAt
          updatedBy
        }
        files {
          _id
          name
          description
          interactionIcon
          path
          type
          data {
            isNotHandout
            isLink
          }
        }
      }

    }
  }
`;
